<template>
  <div>
    <div
      class="foot-t"
      v-if="
        footer_hidden &&
        common_info.footer.footer_advert.is_show == 1 &&
        common_info.footer.footer_advert.list.length
      "
    >
      <div class="w">
        <ul class="foot-t-item">
          <template
            v-for="(item, index) in common_info.footer.footer_advert.list"
          >
            <li v-if="item.pic_url || item.title">
              <img class="img-default" :src="item.pic_url" alt />
              <span v-text="item.title"></span>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="foot-c" v-if="footer_hidden">
      <div class="w foot-c-item">
		  <!-- 普伟龙祥 特有的 -->
		  <!-- <div id="cnzz"></div> -->
        <ul v-for="(item, index) in common_info.help.list" :key="index">
          <li class="foot-title" v-text="item.title"></li>
          <li v-for="(value, key) in item.list" :key="key">
            <router-link
              :to="{ path: '/ttshop_details', query: { article_id: value.id } }"
              v-text="value.title"
            ></router-link>
          </li>
        </ul>
        <ul>
          <li
            class="foot-title"
            v-if="common_info.help.right_content.title"
            v-text="common_info.help.right_content.title"
          ></li>
          <li
            class="introduce"
            v-if="common_info.help.right_content.content"
            v-text="common_info.help.right_content.content"
          ></li>
          <!-- <li class="foot-tel" v-if="common_info.help.copyright.phone" v-text="'TEL：'+common_info.help.copyright.phone"></li> -->
        </ul>
      </div>
    </div>
    <div class="foot-b">
      <div class="w foot-b-item">
        <div class="foot-top">
          <template v-for="(item, index) in common_info.help.links">
            <div>
              <a :href="item.url" target="_blank" v-text="item.name"></a>
              <span class="line"></span>
            </div>
          </template>
        </div>
        <ul class="foot-bottom">
          <li class="public" v-if="common_info.help.copyright.network_card">
            <img src="../../assets/images/gongan.png" alt="" />
            <a
              :href="common_info.help.copyright.network_card_url"
              target="_blank"
              v-if="common_info.help.copyright.network_card_url"
              >{{ common_info.help.copyright.network_card }}</a
            >
          </li>
          <li>
            <a
              :href="common_info.help.copyright.icp_url"
              target="_blank"
              v-text="common_info.help.copyright.icp_card"
              v-if="common_info.help.copyright.icp_url"
            ></a>
            <span v-text="common_info.help.copyright.icp_card" v-else></span>
          </li>
          <li v-text="common_info.help.copyright.text"></li>
          <!-- <li v-text="'Tel: '+common_info.help.copyright.phone"></li> -->
          <li v-if="common_info.help.copyright.statistics_url">
            <a :href="common_info.help.copyright.statistics_url" target="_blank"
              >站长统计</a
            >
          </li>
          <li>
            <a href="https://www.oeob.net/" target="_blank">技术支持</a>
            <span>：</span>
            <a href="http://www.feicaimao.com/" target="_blank">肥财猫</a>
          </li>
          <!-- <li>
						<a href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020181026110956000002915049-SAIC_SHOW_310000-2c9be8bd6f7928c3016fb396d8bc2209417&signData=MEUCIHekuTPuft+9PhsILMpNMyOOmt5EfJ9Alih1o6QjB68LAiEA1V6N1jDDkAcx9dUqUDnbRBMC9IyT+Vyw7KzCcV3mrZY=" target="_blank">
							<img class="img-default" src="../../assets/images/lz2.jpg" alt="" style="width: 14px;">
						</a>
					</li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["footerhidden"],
  components: {},
  data() {
    return {
      common_info: {
        footer: {
          footer_advert: {},
        },
        help: {
          links: {},
          list: {},
          right_content: {},
          copyright: {},
        },
      },
      footer_hidden: true,
    };
  },
  created() {
    let that = this;
    this.common.getCommonInfo(this, function () {
      /* let statistics_url = that.common_info.help.copyright.statistics_url;
				statistics_url = statistics_url.replace('<script type="text/javascript">','');
				statistics_url = statistics_url.replace(';<\/script>','');
				console.log(statistics_url);
				const script = document.createElement('script');
				script.innerText = statistics_url;
				script.language = 'JavaScript';
				document.getElementById('app').appendChild(script); */
      /* const script = document.createElement('script');
				script.innerText = `document.write(unescape("%3Cspan id='cnzz_stat_icon_1279615811'%3E%3C/span%3E%3Cscript src='http://v1.cnzz.com/z_stat.php%3Fid%3D1279615811%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));`;
				script.language = 'JavaScript';
				document.getElementById('app').appendChild(script); */
    });
  },
  mounted() {
    if (this.footerhidden != undefined) {
      this.footer_hidden = this.footerhidden;
    }
    // var cnzzs = "https:" == document.location.protocol ? "https://" : "http://";
    // document.getElementById("cnzz").innerHTML = unescape(
    //   "%3Cspan id='cnzz_stat_icon_1280737938'%3E%3C/span%3E%3Cscript src='" +
    //     cnzzs +
    //     "s9.cnzz.com/z_stat.php%3Fid%3D1280737938' type='text/javascript'%3E%3C/script%3E"
    // );
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.foot-t {
  width: 100%;
  background-color: #fafafa;

  .foot-t-item {
    height: 108px;
    display: flex;
    justify-content: space-between;

    li {
      font-size: 20px;
      color: #333333;
      display: flex;
      align-items: center;

      img {
        display: block;
        width: 37px;
        height: 40px;
        margin-right: 19px;
      }
      span {
        font-size: 20px;
      }
    }
  }
}

.foot-c {
  width: 100%;
  border-top: 1px solid #ebebeb;
  background-color: #fafafa;
  padding: 40px 0;
  box-sizing: border-box;

  .foot-c-item {
    display: flex;
    justify-content: space-between;

    ul {
      color: #888888;

      li {
        margin-bottom: 6px;

        a {
          display: block;
          color: #888;
          line-height: 22px;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      .introduce {
        width: 190px;
        line-height: 20px;
      }

      .foot-tel {
        color: #ff0e25;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .foot-title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 8px;
    }
  }
}

.foot-b {
  width: 100%;
  background-color: #fff;

  .foot-b-item {
    height: 78px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .foot-top {
      display: flex;

      div {
        display: flex;
        align-items: center;
        a {
          color: #888888;
        }
        .line {
          height: 10px;
          width: 1px;
          background-color: #b3b3b3;
          margin: 0 8px;
        }
      }
      div:last-child {
        .line {
          display: none;
        }
      }
    }

    .foot-bottom {
      display: flex;
      color: #bfbfbf;
      align-items: center;
      margin-top: 12px;
      justify-content: center;
      flex-wrap: wrap;
      width: 90%;
      li {
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }

        position: relative;

        + li::before {
          content: "";
          width: 1px;
          height: 10px;
          background: #bfbfbf;
          position: absolute;
          top: 3px;
          left: -7px;
        }

        // &:last-child:before {
        //   display: none;
        // }
        span {
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }
    }
  }
}
.public {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}
</style>
